import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M16 0H4C2.9 0 2 .9 2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm-4 19H8v-3h4v3zm0-4H8v-3h4v3zM3 8h4v3H3V8zm0 4h4v3H3v-3zm5-1V8h4v3H8zm5-3h4v3h-4V8zM4 1h12c.55 0 1 .45 1 1v5H3V2c0-.55.45-1 1-1zM3 18v-2h4v3H4c-.55 0-1-.45-1-1zm13 1h-3v-7h4v6c0 .55-.45 1-1 1z',
    'M6 5h8c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1 .45-1 1s.45 1 1 1z',
  ],
  height: 20,
  width: 20,
});
